// ==============================
// CUSTOM: Safe VAT updater for cart subtotal
// ==============================

console.log('✅ CUSTOM: VAT script loaded');

function updateVatRow() {
  const totalEl = document.querySelector('[data-cart-total]');
  const vatEl = document.querySelector('.custom-vat-row');

  if (!totalEl || !vatEl) {
    console.warn('⚠️ CUSTOM: Missing total or VAT element');
    return;
  }

  const raw = totalEl.textContent.trim();
  const parsed = parseFloat(raw.replace(/[^\d,.-]/g, '').replace(',', '.'));

  if (isNaN(parsed)) {
    console.warn('⚠️ CUSTOM: Could not parse number from:', raw);
    return;
  }

  const exVat = (parsed * 0.8)
  .toFixed(2)
  .replace('.', ',')
  .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const newText = `Pris exkl. moms: ${exVat} kr`;

  if (vatEl.textContent.trim() !== newText) {
    console.log(`🔁 Updating VAT row to: ${newText}`);
    vatEl.textContent = newText;
  } else {
    console.log('✅ No change in VAT value – skipping update');
  }
}

if (window.location.pathname.includes('/cart')) {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('🚀 CUSTOM: Cart page detected, starting VAT observer');

    updateVatRow();

    const observer = new MutationObserver(updateVatRow);
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll('[data-expand-trigger]');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      const currentMenu = trigger.closest('.expandable-menu');
      const content = currentMenu.querySelector('.expandable-content');
      const icon = trigger.querySelector('.expand-icon');
      


      // Stäng andra öppna menyer
      document.querySelectorAll('.expandable-menu .expandable-content').forEach(otherContent => {
        if (otherContent !== content) {
          otherContent.hidden = true;
        }
      });

      // Rotera andra pilar tillbaka
      document.querySelectorAll('.expand-toggle .expand-icon').forEach(otherIcon => {
        if (otherIcon !== icon) {
          otherIcon.classList.remove('expanded');
        }
      });

      // Toggla denna meny
      content.hidden = !content.hidden;
      icon.classList.toggle('expanded');
    });
  });
});

document.querySelectorAll('[data-expand-trigger]').forEach(trigger => {
  trigger.addEventListener('click', function () {
    const content = this.closest('.expandable-menu').querySelector('.expandable-content');
    const parentMenu = this.closest('[data-navmenu-submenu]');

    const isExpanded = !content.hasAttribute('hidden');
    content.toggleAttribute('hidden');

    // Uppdatera höjd om innehållet visas
    if (!isExpanded) {
      const newHeight = parentMenu.scrollHeight;
      parentMenu.style.setProperty('--menu-open-height', `${newHeight}px`);
    }
  });
});
